<template>
  <div class="fl-sym-px-4">
    <div class="fl-sym-mt-20 fl-sym-letter-space-08 fl-sym-text-dark-blue fl-sym-text-xxs regular">
      FORGOT PASSWORD
    </div>
    <div
      class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-bold fl-sym-mb-2 fl-sym-letter-space-minus-02"
    >
      What's your email?
    </div>
    <div class="fl-sym-text-intermediate fl-sym-text-lg">
      Enter your email below to receive your password reset instructions.
    </div>

    <form
      class="fl-sym-mt-16"
      @submit.prevent="submit"
      method="post"
    >
      <div class="fl-sym-border fl-sym-border-graduate fl-sym-rounded fl-sym-px-3 fl-sym-py-1">
        <label for="login">Email</label>
      <input
          id="login"
        placeholder="Email"
        v-model="user.email"
        name="login"
        class="fl-sym-w-full fl-sym-text-lg fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
      />
      </div>
      <span class="error" v-if="errors.login">{{ errors.login[0] }}</span>

      <div class="fl-sym-mt-40 fl-sym-mb-2">
        <button
          type="submit"
          class="fl-sym-bg-primary hover:fl-sym-text-opacity-75 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm"
        >
          Send Reset Link
        </button>
      </div>
      <div class="fl-sym-flex fl-sym-justify-center fl-sym-text-sm fl-sym-mt-4">
        <div class="fl-sym-text-primary hover:fl-sym-text-opacity-75" style="cursor: pointer" @click="back">
          Back
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      user: state => state.auth.user,
      errors: state => state.auth.errors
    })
  },
  methods: {
    back() {
      this.$router.go("-1");
    },
    submit: function () {
      this.$store.dispatch('auth/forgetPassword')
    },
  },
};
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

border-red {
  border-color: #ff3a19;

}
label {
    text-align: left;
    color: #6F7878;
    font-size: 12px;
    letter-spacing: 0.4px;
    line-height: 22px;
}
</style>